<template>
    <div>
                    <v-app>
                            <v-col cols="12" sm="12" md="12" lg="12" xl="12">
                                <v-card outlined width="100%" class="rounded-md">

                                    <v-toolbar flat>

                                        <v-tabs v-model="tab" align-with-title grow>
                                            <v-tabs-slider/>
                                            <v-tab>
                                                <v-icon>mdi-plus-outline</v-icon>
                                                ثبت سفارش جدید
                                            </v-tab>

                                            <v-tab>
                                                <v-icon class="m-2">mdi-basket</v-icon>
                                                سفارش ها
                                            </v-tab>


                                        </v-tabs>
                                    </v-toolbar>

                                    <v-tabs-items touchless v-model="tab">
                                        <!--                    ORDER-->
                                        <v-tab-item>
                                            <transition name="slide-x-transition" mode="out-in">
                                                <banner-stepper @eventname="updateparent" v-if="tab===0 && $route.name==='banner.index'"></banner-stepper>
                                            </transition>
                                        </v-tab-item>

                                        <v-tab-item>
                                            <order-list url="form/graphic/banner" v-if="tab === 1"></order-list>
                                        </v-tab-item>
                                    </v-tabs-items>
                                </v-card>
                            </v-col>

                        <v-dialog
                                v-if="payDialogInfo.payments"
                                v-model="dialogPayment"
                                scrollable
                                max-width="600px"
                                max-height="200px">

                            <v-card :loading="loading" class="p-10">
                                <v-row>
                                    <v-card-title>
                                        پرداخت
                                        {{ payDialogInfo.payments.type === 'final' ? 'نهایی' : 'قسطی' }}
                                    </v-card-title>
                                    <v-spacer></v-spacer>
                                    <v-icon color="red" @click="dialogPayment=false">mdi-close</v-icon>
                                </v-row>
                                <v-divider></v-divider>


                                <v-timeline v-if="payDialogInfo.payments.type==='installment'">
                                    <v-timeline-item v-for="(x,i) in payDialogInfo.payments.transactions"
                                                     :color="x.status==='pending'?'red':'success'"
                                    >
                                        <v-card-title> {{ x.description }}</v-card-title>
                                        <div>
                                            <v-chip color="success" outlined>مبلغ قابل پرداخت:
                                                {{ persian(price(x.price)) }} ﷼
                                            </v-chip>
                                        </div>

                                        <v-btn class="btn-update" @click="pay(x.id)" :disabled="x.status!=='pending'">
                                            پرداخت
                                        </v-btn>
                                    </v-timeline-item>

                                </v-timeline>

                                <v-list two-line v-if="payDialogInfo.payments.type==='final'">
                                    <v-list-item>

                                        <v-list-item-icon>
                                            <v-icon color="indigo">
                                                mdi-currency-usd
                                            </v-icon>
                                        </v-list-item-icon>
                                        <v-list-item-content>
                                            <v-list-item-title>{{
                                                    persian(price(payDialogInfo.payments.price)) + ' ریال'
                                                }}
                                            </v-list-item-title>
                                            <v-list-item-subtitle>
                                                قیمت نهایی
                                            </v-list-item-subtitle>
                                        </v-list-item-content>

                                        <v-list-item-icon class="ml-6">
                                            <v-icon color="indigo">
                                                mdi-calendar-range
                                            </v-icon>
                                        </v-list-item-icon>
                                        <v-list-item-content>
                                            <v-list-item-title> {{
                                                    payDialogInfo.payments.expired_at != null ? persian(jalalian(payDialogInfo.payments.expired_at)) : 'ندارد'
                                                }}
                                            </v-list-item-title>
                                            <v-list-item-subtitle>
                                                مهلت پرداخت
                                            </v-list-item-subtitle>
                                        </v-list-item-content>
                                    </v-list-item>


                                    <v-list-item>

                                        <v-list-item-icon>
                                            <v-icon color="indigo">
                                                mdi-calendar-text-outline
                                            </v-icon>
                                        </v-list-item-icon>
                                        <v-list-item-content>
                                            <v-list-item-title> {{
                                                    payDialogInfo.payments.description != null ? payDialogInfo.payments.description : 'ندارد'
                                                }}
                                            </v-list-item-title>
                                            <v-list-item-subtitle>
                                                توضیحات
                                            </v-list-item-subtitle>
                                        </v-list-item-content>


                                    </v-list-item>


                                    <v-divider inset></v-divider>

                                    <v-list-item>


                                        <v-list-item-content>
                                            <v-list-item-title>
                                                <v-btn class="btn-buy" @click="pay" style="width: 90%">پرداخت</v-btn>
                                            </v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                </v-list>

                                <v-card-text>


                                </v-card-text>
                            </v-card>
                        </v-dialog>
                    </v-app>
    </div>
</template>

<script>
import {SET_BREADCRUMB} from "@/core/services/store/breadcrumbs.module";
import loginRollback from "@/Utilities/LoginRollback";
import jwtService from "@/core/services/jwt.service";
import actionButton from '@/view/content/button'
import siteStatusButton from "@/view/pages/site/siteStatusButton";
import OrderList from "../orderList";
import Stepper from "../stepper";
import BannerStepper from "@/view/pages/site/banner/bannerStepper";

export default {
    components: {BannerStepper, Stepper, OrderList},
    name:"bannerForm",
    data() {
        return {
            step: 1,
            dialogPayment: false,
            payDialogInfo: {},
            payableTransaction: null,
            selectedRows: [],
            paymentLoading: false,
            data: {
                name: null,
                type: null,
                quality: null,
                recommended_sites: [],
                rivals: [],
                programming_language: null,
                site_type: null,
                support_time: null,
            },
            orderTypes: [
                {key: 'design', keyAlias: 'طراحی سایت', icon: '/media/site/aparat.png'},
                {key: 'support', keyAlias: 'پشتیبانی سایت', icon: '/media/site/aparat.png'},
                {key: 'seo', keyAlias: 'سئو سایت', icon: '/media/site/aparat.png'},
            ],
            errors: [],
            dialog: false,
            loading: false,
            errorMsg: '',
            userWallet: [],
            dialogInfo: null,
            tab: null,
            items: [
                'سفارش ها',
                'ثبت سفارش جدید',
            ],
            translate: {
                nextButton: 'بعدی',
                previousButton: 'قبلی',
                rowsPerPageText: 'تعداد در صفحه',
                noDataText: 'داده ای برای نمایش وجود ندارد',
                placeholderSearch: 'جستجو',
            },
            url: 'site',
            userInfo: {},
            tableProps: {
                search: '',
                length: 10,
                column: 'id',
                dir: 'desc',
            },
            tablePropsDefault: {
                search: '',
                length: 10,
                column: 'id',
                dir: 'desc',
            },
            columns: [
                {
                    label: 'ردیف',
                    transform: (val) => {
                        let row = this.userInfo.meta.current_page - 1;
                        row = row * this.userInfo.meta.per_page;
                        return row + val.row + 1;
                    },
                },
                {
                    label: 'شناسه',
                    name: 'id',
                    orderable: true,
                    colStyle: 'width: 100px;'
                },
                {
                    label: 'نام مجموعه',
                    name: 'name',
                    orderable: true,
                },
                {
                    label: 'نوع سفارش',
                    name: 'type',
                    orderable: true,

                },

                {
                    label: 'زبان برنامه نویسی',
                    name: 'programming_language',
                    // transform: (value, data) => {
                    //   return value.data.location ? `${value.data.location[0]} , ${value.data.location[1]}` : 'ندارد'
                    // }
                },

                {
                    label: 'نوع سایت',
                    name: 'site_type',
                    orderable: true,
                    // transform: (value, data) => {
                    //   return value.data.pack.title;
                    // }
                },


                {
                    name: 'status',
                    label: 'وضعیت',
                    handler: this.actions,
                    component: siteStatusButton,
                    event: 'action',
                    // transform: (value, data) => {
                    //   return this.getStatusBadge(value.data.status)
                    // }
                },

                {
                    label: 'عملیات',
                    name: 'actions',
                    component: actionButton,
                    handler: this.actions,
                    event: 'action',
                    permission_prefix: 'user_',
                    meta: {
                        buttons: [
                            {
                                name: "edit",
                                label: "ویرایش اطلاعات سایت",
                                icon: "pencil-alt",
                                type: 'edit',
                                action: (a, b) => {
                                    this.goto(`site/${a.id}`)
                                }
                                , permission: "user_access"
                            },

                        ]
                    }
                },
            ],
            statusBadge: '',
            userValid: true,
            isRejected: false,
            isPending: false,
            userInfoGot: false
        }
    },
    methods: {
        updateparent(variable) {
            this.tab = variable
        },
        paymentDialog(data) {
            this.payDialogInfo = data
            this.dialogPayment = true
        },
        step1Validate() {
            if (!this.data.name || !this.data.type) {
                this.$toast.error('لطفا اطلاعات اولیه سفارش خود را تکمیل کنید!')
                return
            }
            this.step = 2
        },
        getUserInfo() {
            this.userInfoGot = true;
            this.$modal.showLoading();
            this.requestApiGet('userInfo')
                .then(res => {
                    this.$modal.hideLoading();
                    let response = res.data.data
                    console.log(response.status)
                    if (response.status == 'accept') {
                        this.userValid = true
                        this.statusBadge = 'accept'
                    } else if (response.status == 'reject') {
                        this.isRejected = true
                        this.userValid = false
                        this.statusBadge = 'reject'
                        let _this = this;
                        this.$modal.error('اطلاعات تکمیلی نیاز به ویرایش دارد', 'اطلاعات شما دارای مشکل میباشد',
                            undefined,
                            {},
                            [
                                {
                                    text: "رفتن به صفحه تکمیل اطلاعات",
                                    onClick() {
                                        _this.$router.push({path: "/company-register"});
                                    }
                                }
                            ]
                        )
                    } else if (response.status == 'pending') {
                        this.isPending = true
                        this.userValid = false
                        this.statusBadge = 'pending'
                        this.$modal.warning('در انتظار تایید اطلاعات',
                            'در مرحله در انتظار تایید توسط پشتیبانی شما قادر به ثبت بیلبورد نمیباشید.')
                    } else {
                        this.userValid = false
                        this.statusBadge = ''
                        let _this = this;
                        this.$modal.info('اطلاعات خود را تکمیل کنید',
                            'تا زمانی که اطلاعات خود را تکمیل نکنید قادر به ثبت بیلبورد نمیباشید.',

                            undefined,
                            {},
                            [
                                {
                                    text: "تکمیل اطلاعات",
                                    onClick() {
                                        _this.$router.push({path: "/company-register"});
                                    }
                                }
                            ]
                        )
                    }
                })
                .catch(res => {
                    this.$modal.hideLoading();
                })
        },
        submit() {
            this.errors = [];
            this.requestApiPost(`site`, this.createFormData(this.data))
                .then((res) => {
                    if (res.status && res.status == 201) {
                        this.getSites()
                        this.tab = 0
                        this.$toast.success('با موفقیت ثبت شد.')
                    } else {
                        this.$toast.warning('لطفا مجددا تلاش کنید')
                    }
                })
                .catch((e) => {
                    this.$toast.error('خطا در ثبت')
                    this.errors = e.response.data.errors
                })
                .finally(() => {
                    this.$modal.hideLoading();
                })
        },
        pay(transactionId) {
            if (this.payDialogInfo.payments.type === 'final') {

                this.requestApiPost(`payment/${this.payDialogInfo.id}/pay`, {transaction_id: this.payDialogInfo.payments.transactions[0].id})
                    .then(response => {
                        this.$toast.success('با موفقیت پرداخت شد!')
                        this.getSites()
                        this.dialogPayment = false
                    }).catch(({res}) => {
                    this.loading = false
                    this.$toast.error(res.data.message)
                })


            } else {
                this.requestApiPost(`payment/${this.payDialogInfo.id}/pay`, {transaction_id: transactionId})
                    .then(response => {
                        this.$toast.success('با موفقیت پرداخت شد!')
                        this.getSites()
                        this.dialogPayment = false
                    }).catch(({res}) => {
                    this.loading = false
                    this.$toast.error(res.data.message)
                })

            }
        },
        getStatusBadge(status) {
            let text = status;
            let color = 'light'

            switch (status) {
                case "pending":
                    text = 'در انتظار تایید';
                    color = 'warning'
                    break;


                case "accept":
                    text = 'منتظر پرداخت';
                    color = 'info'
                    break

                case "reject":
                    text = 'رد شده';
                    color = 'danger'
                    break

                case "disable":
                    text = 'مسدود';
                    color = 'light'
                    break
            }

            return `<span class="badge badge-${color}">${text}</span>`;
        },
        selectAll(c) {
            window.Vue.$emit("selectedAllCheckbox", c);
        },
        change(data, checked) {
            if (checked) {
                this.selectedRows.push(data.id);
            } else {
                let index = this.selectedRows.indexOf(data.id)
                this.selectedRows = [
                    ...this.selectedRows.slice(0, index),
                    ...this.selectedRows.slice(index + 1, this.selectedRows.length)
                ]

            }
            window.document.querySelector("#select_all").checked = this.selectedRows.length == this.userInfo.data.length

        },
        getSites(url = this.url, params = this.tableProps) {
            this.$modal.showLoading();
            this.requestApiGet(url, params).then(response => {
                this.userInfo = response.data;
            }).finally(() => {
                this.$modal.hideLoading();
                if (!this.userInfoGot) {
                    this.getUserInfo();
                }
            })
        },
        reloadTable(params) {
            this.getSites(this.url, params)
        },
        actions(data, type) {
            this[type](data)
        },
        edit(data) {
            this.$router.push({name: 'admin.user.edit', params: {id: data.id}})
        },
        information(data) {
            this.$router.push({name: 'admin.users.information', params: {id: data.id}})
        },
        checkout(data) {
            this.$modal.showLoading();
            this.getUserTokenWithId(data.id)
                .then((token) => {
                    loginRollback.addLogin(this.getUser().name, jwtService.getToken())
                    jwtService.saveToken(token)
                    window.location.reload();
                }).catch((e) => {
                this.$toast.error("error")
            })
                .finally(() => {
                    this.$modal.hideLoading();
                })
        },
    },

}

$('#select_all').click(function () {
    $('.checkBox').prop('checked', $(this).prop("checked"));
})
</script>
<style scoped>
.alert-warn {
    background-color: #CFD8DC;
}

.pending-status {
    background-color: rgb(224, 224, 94);
    padding: 0px 5px 0px 5px;
    font-weight: bold;
}

.accept-status {
    background-color: green;
    padding: 0px 5px 0px 5px;
    color: white;
    font-weight: bold;
}

.reject-status {
    background-color: red;
    padding: 0px 5px 0px 5px;
    color: white;
}
</style>
